// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"41018ce7","156":"798311f1","165":"d9f73bae","423":"d4a3ac68","511":"1ed6969f","574":"897f9aaf","749":"76165c7b","819":"54e0c3d6"}[chunkId] + ".chunk.js";
};